import { BaseEndpoint } from "./BaseEndpoint";
import { WithDelete } from "./mixins/WithDelete";

export class Endpoint extends BaseEndpoint("contracts") {}

export const ContractEndpoint = WithDelete(Endpoint);
